module.exports.reloadLayerCatridge = function(tPath, tUrl, callback) {

  // Empty #layerCartridge
  cube.$id('layerCartridge').innerHTML = '';

  // Include an empty DIV in #layerCartridge
  var cartridgeInner = document.createElement('div');
  cartridgeInner.id = 'test-reload-cartridge';
  cartridgeInner.dataset.tPath = tPath;
  cartridgeInner.dataset.tUrl = tUrl;

  cube.$id('layerCartridge').appendChild(cartridgeInner);
  
  // Configure reload cartridge
  var cartridge = cube.cartridge('test-reload-cartridge');
  cartridge.after(callback);

  // Execute reload cartridge
  cartridge.reload();
  
};



// WEBPACK FOOTER //
// ./src/modules-es5/commons/layout/nav-utils.js